// Static UI data for the Gallery theming studio. Presets + wallpaper tabs reuse
// the app's existing preset arrays (constants/background.js) wherever the deck
// calls for solid/gradient swatches.
//
// ISP-9999 (gordon-0913-gallery-theme-wallpaper-pattern-image-parity): the
// Pattern tab used to render 4 invented, hardcoded CSS-gradient swatches here
// (PATTERN_PRESETS). Removed — the Pattern tab now browses the REAL 28-pattern
// library shared with the Edit-Wheel builder (see PATTERN_IDS in
// galleryTheme.js, sourced from SegmentBuilder/Shared/Wallpaper/children/
// Patterns/Pattern.jsx), not a 4-swatch stand-in.
import {
  GALLERY_PRESETS,
  DEFAULT_PRESET_ID,
  DEFAULT_GALLERY_PRESET,
} from "./galleryTheme";

// Preset looks (one tap, done). Tile preview mirrors the deck: a wallpaper
// rectangle with an accent dot. "Default" (the out-of-the-box Gallery look)
// is always the FIRST tile (Gordon law 2026-09-16), then the curated presets.
export const PRESET_LOOKS = [
  [DEFAULT_PRESET_ID, DEFAULT_GALLERY_PRESET],
  ...Object.entries(GALLERY_PRESETS),
].map(([id, p]) => ({
  id,
  label: p.label,
  wallpaper: p.wallpaper,
  accent: p.accent,
  bg_color: p.bg_color,
}));

// Wallpaper picker tabs (elevated round 2: Color | Gradient | Pattern | Image).
export const WALLPAPER_TABS = [
  { id: "color", label: "Color" },
  { id: "gradient", label: "Gradient" },
  { id: "pattern", label: "Pattern" },
  { id: "image", label: "Image" },
];

// Sample palettes for the self-contained Color Library modal (visual language
// mirrored from SegmentBuilder/Shared/ColorPalette/ColorLibrary). Real saved
// palettes replace these when the user has any (see hook).
export const SAMPLE_PALETTES = [
  { id: "brand", name: "Brand colors", colors: ["#FFFFFF", "#F79A00", "#29C18C", "#9B5AF8", "#123051"] },
  { id: "sunset", name: "Sunset pop", colors: ["#0083FE", "#9B5AF8", "#F79A00", "#E25297", "#123051"] },
  { id: "neutrals", name: "Studio neutrals", colors: ["#F0EADB", "#D6D7D8", "#AAABAD", "#8BA6C2", "#123051"] },
  { id: "dusksky", name: "Dusk sky", colors: ["#F79781", "#E9ADCA", "#9B5AF8", "#123051"] },
  { id: "meadow", name: "Meadow", colors: ["#FFEDAE", "#C4DD81", "#29C18C", "#093028"] },
  { id: "iris", name: "Iris tints", colors: ["#EDE0FD", "#D4BBFF", "#BE95FF", "#9B5AF8"] },
];

// Tokens lifted from the deck / theme.js so the studio matches the app 1:1.
export const T = {
  primary: "#9B5AF8",
  primarySoft: "#EDE0FD",
  ink: "#123051",
  sectionTitle: "#0F0F0F",
  muted: "#565556",
  line: "#e1e1e1",
  dashed: "#BBBBBB",
  surface: "#F6F7F9",
  fontBody: "DM Sans",
};
